import CreatePosition from "./Components/CreatePosition";

export default CreatePosition;
